import React from "react";
import styled from "styled-components";
import {
  colors,
  AnimateIn,
  TitleSet,
  Container, InternalLink,
  media
} from "../../ui-components";

import { EN_AU, DE_DE } from "../../utils/geo-space-id-helpers";

/**
 * Renders the footer CTA section. Function is specific to the career pages.
 *
 * @function renderFooterCTA
 * @returns {JSX}
 */
const renderFooterCTA = (content, geoSpace) => {
  return (
    <FooterCtaWrapper>
      <AnimateIn onScroll direction="none">
      <TitleContainer full>
          <TitleSet
          title={content.OPENINGS__TITLE}
          bodyText={content.CTA__BODY}
          bodyTextSize={'medium'}
          />
          <ButtonContainer>
          {(geoSpace === EN_AU || geoSpace === DE_DE) ? (
              <InternalLink linkstyle="primary-button" to={content.FOOTER__JOBS__BUTTON__URL}>
                {content.FOOTER__JOBS__BUTTON}
              </InternalLink>
            ) : (
            <>
              <InternalLink linkstyle="primary-button" to={content.FOOTER__PRIMARY__BUTTON__URL}>
                {content.FOOTER__PRIMARY__BUTTON}
              </InternalLink>
              <InternalLink linkstyle="secondary-button" to={content.FOOTER__SECONDARY__BUTTON__URL}>
                {content.FOOTER__SECONDARY__BUTTON}
              </InternalLink>
            </>
          )}
          </ButtonContainer>
        </TitleContainer>
      </AnimateIn>
    </FooterCtaWrapper>
  );
};

const FooterCtaWrapper = styled.div`
background-color: ${colors.lightSky};
text-align: center;
`;

const TitleContainer = styled(props => <Container {...props} />)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 80px;
  background-color: ${colors.lightSky};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  gap: 24px;

  @media screen and (max-width: ${media.mediumBottom}) {
    align-items: center;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
  }
`;

export { renderFooterCTA }